import React from 'react';
import config from '../../config';
import { compose } from 'recompose';
import { TransLink } from '../Common/Translations';
import OwlCarousel from '../OwlCarousel/Carousel';
import { withStoreDetail } from '../Common/Providers/WithStoreDetail';
import { willHideOnMuslimPro } from '../Common/Store/Store';
import { withResizeHelper } from '../Common/ResizeHelper';

const s3Path = `${config.s3BucketUrl}/pages/landing`;

const BulkOrderBanner = (props) => {
  const { t, breakpoint } = props;
  const isSmallScreen = breakpoint === 'xs' || breakpoint === 'sm';
  const bannerImage = isSmallScreen
    ? t('landing_page.bulkorder_banner_mobile', '')
    : t('landing_page.bulkorder_banner_desktop', '');
  return (
    <div id="bulkorder_banner" className="m-auto bg bg-gray-lighten-3 lazyload" data-bg={`${s3Path}${bannerImage}`} style={{  maxWidth: '1680px' }}>
      <div className="container mb-5 px-0">
        <div className="row mx-0 align-items-center">
          <div className="col-md-5 text-center text-md-left py-5 text-white">
              <h2 className="ProximaNova-Bold">{t('landing_page.bulkorder_banner_title', 'Order In Bulk & Save Even More')}</h2>
              <p>{t('landing_page.bulkorder_banner_paragraph1', 'Enjoy special discounts for your large printing orders.')}</p>
              <TransLink url={t('landing_page.bulkorder_banner_link', '/bulk-order')} className="btn btn-secondary">{t('landing_page.bulkorder_banner_button', 'Get A Quote')}</TransLink>
          </div>
          {!isSmallScreen &&
          <div className="col-md-6 ml-auto">
            <img className="img-fluid lazyload" alt='Bulk Order Photo' data-src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='600' height='400'></svg>" width="600" height="400"/>
          </div>}
          {isSmallScreen &&
          <img className="img-fluid lazyload" alt='Bulk Order Photo' data-src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='720' height='360'></svg>" width="720" height="360"/>}
        </div>
      </div>
    </div>
  );
};

const owlOptionsTestimonial = {
  items: 1,
  rewind: true,
  slideBy: 1,
  nav: true,
  loop: true,
  navContainerClass: 'owl-custom-nav',
  navClass: ['owl-custom-prev ml-2', 'owl-custom-next mr-2'],
  navText: [
    '<i class="fa fa-chevron-left text-primary"></i>',
    '<i class="fa fa-chevron-right text-primary"></i>'
  ],
  mouseDrag: true,
  dots: false,
  autoplay: true,
  dotsClass: 'owl-dots',
  dotClass: 'owl-dot owl-landing-page-dot',
};

const OwlTemplateTestimonial = ({ text, name }) => (
  <div className="text-center mx-5 px-lg-5">
    <q className="mb-2 text-gray h4">{text}</q>
    <p className="mb-0 bulk-info__text h6">{name}</p>
  </div>
);

const GuaranteeFocus = ({ img, title, desc }) => (
  <div className="col-6 col-lg-3 text-center text-gray mb-3">
    <img className="img-fluid m-auto w-50 lazyload" data-src={`${config.s3BucketUrl}/pages/${img}`} width="143" height="92" alt={title}/>
    <h6 className="ProximaNova-Bold mb-2">{title}</h6>
    <p className="small mb-0 d-none d-md-block">{desc}</p>
  </div>
);

const CustomContentAndTestimonials = (props) => {
  const {
    t,
  } = props;
  return (
    <div className="my-5 content-visibility-auto">
      <BulkOrderBanner {...props}/>

      <div id="testimonial" className="bg-primary-lighten-2 my-5 py-5">
        <div className="container">
          <div className="text-center">
              <h2 className="ProximaNova-Bold landing-h4">{t('landing_page.testimonial_title', 'What Our Customers Are Saying')}</h2>
          </div>

          <div id="testimonialContainer" className="row justify-content-center text-center">
            <div className="col-lg-8">
              <OwlCarousel options={owlOptionsTestimonial}>
                <OwlTemplateTestimonial text={t('landing_page.testimonial_text_1', 'Making our memories last on paper with a very affordable price')}
                                        name={t('landing_page.testimonial_name_1', 'Hanaz')} />
                <OwlTemplateTestimonial text={t('landing_page.testimonial_text_2', 'Customer service is awesome. Product looks amazing!')}
                                        name={t('landing_page.testimonial_name_2', 'Fairus F')} />
                <OwlTemplateTestimonial text={t('landing_page.testimonial_text_3', 'It is so easy to create different projects using the website! I really enjoy that! I was also pleasantly surprised at the exceptional customer service i received when i had questions about my latest project.')}
                                        name={t('landing_page.testimonial_name_3', 'Kimberly F')} />
                <OwlTemplateTestimonial text={t('landing_page.testimonial_text_4', 'The memories of my adventures/escapades will be treasured and will last for a lifetime through the photobooks that i made.')}
                                        name={t('landing_page.testimonial_name_4', 'Josie')} />
                <OwlTemplateTestimonial text={t('landing_page.testimonial_text_5', 'I love the quality of the product. I get one every year for my family. The layouts are easy to change and adapt to suit my needs.')}
                                        name={t('landing_page.testimonial_name_5', 'Erin M')} />
                <OwlTemplateTestimonial text={t('landing_page.testimonial_text_6', 'Producing & formatting the photos was easy & then upon receiving the completed product was absolutely amazing & so spectacular')}
                                        name={t('landing_page.testimonial_name_6', 'Mitchell G')} />
              </OwlCarousel>
            </div>
          </div>

          <hr className="bg-gray-lighten-3 my-5" />

          <div className="row justify-content-center text-center">
            <GuaranteeFocus img={t('landing_page.guaranteeFocus_image_2', 'home_icon_shipping.png')}
                            title={t('landing_page.guaranteeFocus_title_2', 'Free Express Shipping*')}
                            desc={t('landing_page.guaranteeFocus_desc_2', 'You are entitled for FREE express shipping upon spending a qualifying amount on our products.')} />
            <GuaranteeFocus img={t('landing_page.guaranteeFocus_image_3', 'home_icon_quality.png')}
                            title={t('landing_page.guaranteeFocus_title_3', '100% Quality Guarantee')}
                            desc={t('landing_page.guaranteeFocus_desc_3', '100% Quality Guarantee is all about your satisfaction. We want you to be HAPPY.')} />
            <GuaranteeFocus img={t('landing_page.guaranteeFocus_image_4', 'home_icon_personalization.png')}
                            title={t('landing_page.guaranteeFocus_title_4', 'Free Personalization Options')}
                            desc={t('landing_page.guaranteeFocus_desc_4', 'Providing you with full personalization and creative control is the nature of our business.')} />
          </div>
          <div className="text-center">
              <TransLink url={t('landing_page.guarantee_link', '/guarantee')}>{t('landing_page.guarantee_link_text', '*Terms and conditions apply')}</TransLink>
          </div>

        </div>
      </div>
    </div>
  );
};

const enhance = compose(
  withStoreDetail,
  willHideOnMuslimPro,
  withResizeHelper,
);
export default enhance(CustomContentAndTestimonials);
export const undecorated = CustomContentAndTestimonials;



// WEBPACK FOOTER //
// ./src/LandingPage/CustomContentAndTestimonials.js